import React, {useCallback} from 'react';
import {useDispatch} from 'react-redux';


import {useUserTypes} from 'src/hooks/dictionaries';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {applyUpdatedData, setType} from 'src/modules/create-user/user-bulk-import/services/user-bulk-import.slice';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import Icon, {Icons} from '@pb/kit-component-icon';

import type {UserType} from 'src/openapi/admin/models/UserType';

type Props = {
    selectedRecordIds: number[],
};

export const SetType = ({selectedRecordIds}: Props) => {
    const dispatch = useDispatch();
    const {userFieldChange} = useEventTracking();

    const {userTypes} = useUserTypes();

    const selectType = useCallback((userType: UserType) => {
        dispatch(applyUpdatedData());
        dispatch(setType({ids: selectedRecordIds, userType}));

        userFieldChange({
            section: 'Validate File',
            parameterName: 'Type',
            viewType: 'Bulk Import Users',
        });
    }, [selectedRecordIds, dispatch, userFieldChange]);

    return (
        <DropdownMenu anchor={({positionRef, getAnchorProps, anchorRef}) => (
            <FlatButton
                endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                {...getAnchorProps()}
                ref={anchorRef}>
                <b>Set Type</b>
            </FlatButton>
        )}>
            {userTypes.map(({code, description}) => (
                <DropdownMenuItem
                    key={code}
                    caption={description}
                    onClick={() => selectType(code as UserType)}
                />
            ))}
        </DropdownMenu>
    );
};
